import Button from '@mui/material/Button';

const StyledButton = ({ onClickHandler, label, height, width }) => {
  return (
    <Button variant="contained" onClick={onClickHandler} sx={{ height: { height }, width: '100%' }}>
      {label}
    </Button>
  );
};

export default StyledButton;
